import { RouteUpdateArgs } from "gatsby";

let activeCallback: typeof gtagPageViewCallback | null = null;

export const gtagPageViewCallback = ({ location }: Pick<RouteUpdateArgs, "location">) => {
    const pagePath = location ? location.pathname + location.search + location.hash : undefined;
    safeGTag("event", "page_view", { pagePath });
};

export const initGTagCallback = (): boolean => {
    const isAlreadyInit = !!activeCallback;

    activeCallback = gtagPageViewCallback;

    if (!isAlreadyInit) {
        // Fire the initial GTM event
        safeGTag("event", "gtm.js", { "gtm.start": new Date().getTime() });
    }
    return isAlreadyInit;

};
export const triggerGTagCallback = (arg: Pick<RouteUpdateArgs, "location">) => {
    if (activeCallback && !!arg) {
        activeCallback(arg);
    }
};

// Guarded D.R.Y. function for sending data into a `gtag` call.
export function safeGTag(...values: unknown[]) {
    try {
        if (typeof window !== "undefined" && "gtag" in window && typeof window.gtag === "function") {
            window.gtag(...values);
        }
    } catch {}
}

export const GTAG_ID = "G-FN8GDP1TV3";
export const GTM_ID = "GTM-5CFXN6P";
